(function() {
    'use strict';
a3_cabin_reports.factory('AssessmentSyncResultFactory', AssessmentSyncResultFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name AssessmentSyncResultFactory
    * @description 
    *   Add, Update, Delete and Get Cabin Crew Feedback Sync Results.
    * @ngInject
    */
function AssessmentSyncResultFactory(GenericService) {

        /**
        * Initialize the CrewAssessment
        * @memberof AssessmentSyncResultFactory
        */
		function AssessmentSyncResult() {
			this.Route = null;
			this.DutyDate = null;
			this.message = null;
			this.success = null;
		}

		var objType = 'assessmentSyncResults';
		var objCallback = AssessmentSyncResult;  
		
		var service = {
			getAssessmentSyncResultsFromStorage: getAssessmentSyncResultsFromStorage,
			setAssessmentSyncResultsToStorage : setAssessmentSyncResultsToStorage,
			getSuccesses : getSuccesses,
			getFailures : getFailures
		}

         /**
         * Get Assessment Sync Results
         * @memberof AssessmentSyncResultFactory
         * @returns {Array} AssessmentSyncResults 
         */
		function getAssessmentSyncResultsFromStorage() {
			return GenericService.list(objType,objCallback);
		}

        /**
         * Save Assessment Sync Results in Local Storage
         * @memberof AssessmentSyncResultFactory
         * @param {Array} AssessmentSyncResults A list of Assessment Sync Results
         */
		function setAssessmentSyncResultsToStorage(assessmentSyncResults) {
			GenericService.saveAll(assessmentSyncResults,objType,objCallback);
		}

         /**
         * Get Successfull Assessment Sync Results from Local Storage
         * @memberof AssessmentSyncResultFactory
         * @param {Array} AssessmentSyncResults A list of Assessment Sync Results
         * @returns {Array} AssessmentSyncResults 
         */
		function getSuccesses(syncResults) {
			var result = 0;
			if (!syncResults) {
				return result;
			}
			for (var i = 0; i < syncResults.length; i++) {
				if (syncResults[i].success == true) {
					result = result + 1;
				}
			}

			return result;
		}

    
         /**
         * Get Failed Assessment Sync Results from Local Storage
         * @memberof AssessmentSyncResultFactory
         * @param {Array} AssessmentSyncResults A list of Assessment Sync Results
         * @returns {Array} AssessmentSyncResults 
         */
		function getFailures(syncResults) {
			var result = 0;
			if (!syncResults) {
				return result;
			}
			for (var i = 0; i < syncResults.length; i++) {
				if (syncResults[i].success == false) {
					result = result + 1;
				}
			}

			return result;
		}

		return service;
	}
        
})();